/* ==========================================================================
   MONTT.CO — ABOUT US (scroll horizontal)
   --------------------------------------------------------------------------
   Sem dependência nenhuma. Não usa GSAP de propósito: o site já carrega GSAP
   na home, mas sobre.html não carrega, e o efeito aqui é simples o bastante
   para não justificar puxar 70kb de biblioteca só por causa dele.

   COMO FUNCIONA
   A seção .au é alta (a altura é calculada aqui, não fica chumbada no CSS).
   Essa altura é a "distância de scroll". Dentro dela, .au-pin gruda no topo
   com position:sticky. Conforme o usuário rola dentro da seção, o .au-track
   é transladado no eixo X proporcionalmente. É a mesma mecânica da EME.

   RITMO
   AU_PACE é quantos pixels de scroll vertical valem 1px de movimento
   horizontal. A EME usa 2.33 no desktop e 1.93 no celular — muito lento, e a
   página deles não tem mais nada além disso. Aqui é 1.25 / 1.10, que dá peso
   sem virar maratona. Suba para mais lento, desça para mais direto.

   FLUIDEZ
   O track não segue o scroll na bala: ele persegue o alvo com uma
   interpolação por quadro (AU_SUAVE). É isso que dá o deslize — sem isso o
   movimento é correto mas duro. Com prefers-reduced-motion a interpolação é
   desligada e o track cola no alvo.

   PARALLAX
   Alguns elementos andam mais rápido que o track. Medido na EME, o modelo é
   linear puro: posição = estática + velocidade × deslocamento do track. Quem
   tem data-speed ganha um --px extra; o CSS soma esse --px no transform.
   Velocidades medidas na referência: vídeo do bloco 3 = 1.088, vídeo do
   bloco 7 = 1.050, selo = 1.217.

   MOBILE
   Continua horizontal, igual à referência. A única situação em que a seção
   vira pilha vertical é prefers-reduced-motion — quem pediu ao sistema para
   reduzir movimento não deve receber conteúdo que anda sozinho na tela.
   ========================================================================== */
(function () {
  'use strict';

  var AU_PACE        = 1.25;
  var AU_PACE_MOBILE = 1.10;
  var AU_SUAVE       = 0.14;   /* 0..1 — quanto do caminho o track cobre por quadro */
  var BREAKPOINT     = 860;

  var section = document.querySelector('.au');
  if (!section) return;

  var pin      = section.querySelector('.au-pin');
  var track    = section.querySelector('.au-track');
  var progress = section.querySelector('.au-progress span');
  var hint     = section.querySelector('.au-hint');
  if (!pin || !track) return;

  var reduced = window.matchMedia('(prefers-reduced-motion: reduce)');
  var travel = 0, startY = 0, range = 0, active = false, ticking = false;

  /* alvo = onde o track deveria estar agora; atual = onde ele está de fato */
  var alvo = 0, atual = 0, rodando = false, prog = 0;

  /* elementos com parallax próprio */
  var soltos = [];
  Array.prototype.forEach.call(section.querySelectorAll('[data-speed]'), function (el) {
    var v = parseFloat(el.getAttribute('data-speed'));
    if (v && v !== 1) soltos.push({ el: el, v: v });
  });

  function isStacked() {
    return reduced.matches;
  }

  function pace() {
    return window.innerWidth <= BREAKPOINT ? AU_PACE_MOBILE : AU_PACE;
  }

  function measure() {
    if (isStacked()) {
      active = false;
      section.style.height = '';
      track.style.transform = '';
      for (var k = 0; k < soltos.length; k++) soltos[k].el.style.setProperty('--px', '0px');
      if (progress) progress.style.width = '0';
      return;
    }

    /* Zera o transform antes de medir: com o track deslocado, o scrollWidth
       continua certo, mas um layout em andamento pode devolver valor velho. */
    /* NÃO zera atual/alvo/transform aqui: no celular, a barra de endereço
       aparecendo e sumindo dispara resize sem parar, e zerar o track a cada
       remedição o jogava de volta ao início para depois deslizar de novo —
       era o "pulo" ao rolar de novo depois de voltar ao topo. O scrollWidth
       não depende do transform, então medir com o track deslocado é seguro. */

    var pinW = pin.clientWidth;
    var pinH = pin.clientHeight;
    travel = Math.max(0, track.scrollWidth - pinW);

    if (travel === 0) {           /* track cabe na tela: não há o que animar */
      active = false;
      section.style.height = '';
      return;
    }

    section.style.height = Math.round(pinH + travel * pace()) + 'px';

    var headerH = parseFloat(
      getComputedStyle(document.documentElement).getPropertyValue('--header-h')
    ) || 0;

    startY = section.getBoundingClientRect().top + window.pageYOffset - headerH;
    range  = section.offsetHeight - pinH;
    active = range > 0;

    update();
  }

  function update() {
    if (!active) return;
    var p = (window.pageYOffset - startY) / range;
    p = p < 0 ? 0 : (p > 1 ? 1 : p);

    alvo = -p * travel;
    prog = p;
    if (hint) hint.classList.toggle('is-gone', p > 0.02);
    ligarLoop();
  }

  function desenhar() {
    track.style.transform = 'translate3d(' + atual.toFixed(2) + 'px,0,0)';
    for (var i = 0; i < soltos.length; i++) {
      soltos[i].el.style.setProperty('--px', ((soltos[i].v - 1) * atual).toFixed(2) + 'px');
    }
    if (progress) progress.style.width = (travel ? (-atual / travel) * 100 : 0).toFixed(2) + '%';
  }

  function ligarLoop() {
    if (rodando) return;
    rodando = true;
    requestAnimationFrame(passo);
  }

  function passo() {
    var d = alvo - atual;
    if (reduced.matches || Math.abs(d) < 0.08) {
      atual = alvo; rodando = false; desenhar(); return;
    }
    atual += d * AU_SUAVE;
    desenhar();
    requestAnimationFrame(passo);
  }

  function onScroll() {
    if (ticking) return;
    ticking = true;
    requestAnimationFrame(function () { update(); ticking = false; });
  }

  window.addEventListener('scroll', onScroll, { passive: true });
  /* Só a ALTURA muda quando a barra de endereço mostra/esconde (a banda é em
     svh e não muda); remedir nesse caso só causa tranco. Largura mudou =
     rotação ou redimensionamento de verdade. */
  var lastW = window.innerWidth;
  window.addEventListener('resize', function () {
    if (window.innerWidth === lastW) return;
    lastW = window.innerWidth;
    measure();
  });
  /* No celular a barra de endereço some e volta durante o scroll, o que muda
     a altura do viewport e dispara resize o tempo todo. Como a altura da
     banda é em svh (a menor das duas), a medida não muda — mas orientationchange
     muda de verdade e precisa de uma remedição. */
  window.addEventListener('orientationchange', function () { setTimeout(measure, 250); });
  window.addEventListener('load', measure);
  if (reduced.addEventListener) reduced.addEventListener('change', measure);

  /* --header-h só existe depois que o main.js mede o header. Ele mede no
     DOMContentLoaded e de novo no resize; remedimos logo depois para não
     depender da ordem em que os scripts carregam. */
  measure();
  setTimeout(measure, 120);
  setTimeout(measure, 600);

  /* As fontes trocam de Public Sans para Neue Haas quando os .otf chegam, e
     isso muda a largura dos blocos de texto — logo, a largura do track. */
  if (document.fonts && document.fonts.ready) document.fonts.ready.then(measure);
})();

/* ==========================================================================
   MONTT.CO — ABOUT US, SEGUNDO ATO (referência Scuffers)
   --------------------------------------------------------------------------
   Duas coisas, nenhuma biblioteca:
   1. A revelação: IntersectionObserver com threshold .75 põe e tira a classe
      .is-visible. Tirar também importa — é o que faz a cena voltar a borrar
      quando sai da tela, e revelar de novo na volta. É assim na referência.
   2. O carrossel: clique-e-arraste com Pointer Events, com inércia. De
      propósito NÃO anda com o scroll — foi o pedido, e é o comportamento da
      referência.
   ========================================================================== */
(function () {
  'use strict';

  var cenas = document.querySelectorAll('.sc-scene, .sc-carousel');
  if (cenas.length && 'IntersectionObserver' in window) {
    var obs = new IntersectionObserver(function (entradas) {
      entradas.forEach(function (e) {
        e.target.classList.toggle('is-visible', e.isIntersecting && e.intersectionRatio >= 0.75);
      });
    }, { root: null, threshold: [0.75] });
    Array.prototype.forEach.call(cenas, function (c) { obs.observe(c); });
  } else {
    /* Sem suporte, melhor entregar tudo legível do que tudo borrado. */
    Array.prototype.forEach.call(cenas, function (c) { c.classList.add('is-visible'); });
  }

  /* ---------------------------------------------------------------------- */

  var rail  = document.getElementById('scRail');
  var track = rail && rail.querySelector('.sc-track');
  if (!rail || !track) return;

  var hint    = document.querySelector('.sc-drag-hint');
  var reduzir = window.matchMedia('(prefers-reduced-motion: reduce)');

  var x = 0, min = 0;
  var arrastando = false, idPonteiro = null;
  var xInicial = 0, xBase = 0, moveu = 0;
  var ultimoX = 0, ultimoT = 0, velocidade = 0, inercia = null;

  function medir() {
    /* O quanto o trilho pode andar para a esquerda. Os slides são
       transladados por CSS, então scrollWidth não conta o deslocamento do
       último: a largura real do conteúdo sai do retângulo de cada slide.

       A referência é a borda esquerda do track JÁ DESLOCADA — não a posição
       original. Assim `r.right - base` é sempre o offset da peça dentro do
       track, independente de onde o carrossel esteja. Descontar o
       deslocamento aqui fazia o limite encolher a cada medição feita com o
       carrossel fora da posição inicial, e o fim ia ficando cada vez mais
       perto. */
    var slides = track.querySelectorAll('.sc-slide');
    var direitaMax = 0;
    var base = track.getBoundingClientRect().left;
    Array.prototype.forEach.call(slides, function (s) {
      var r = s.getBoundingClientRect();
      direitaMax = Math.max(direitaMax, r.right - base);
    });
    /* o mesmo respiro do começo, repetido no fim */
    var folga = parseFloat(getComputedStyle(track).paddingLeft) || 0;
    min = Math.min(0, rail.clientWidth - direitaMax - folga);
    aplicar(x);
  }

  function aplicar(v) {
    x = Math.max(min, Math.min(0, v));
    track.style.transform = 'translate3d(' + x.toFixed(2) + 'px,0,0)';
  }

  function pararInercia() {
    if (inercia) { cancelAnimationFrame(inercia); inercia = null; }
  }

  function soltar() {
    pararInercia();
    if (reduzir.matches || Math.abs(velocidade) < 0.04) return;
    var v = velocidade * 16;
    (function passo() {
      v *= 0.94;
      aplicar(x + v);
      if (Math.abs(v) > 0.4 && x > min && x < 0) inercia = requestAnimationFrame(passo);
      else inercia = null;
    })();
  }

  rail.addEventListener('pointerdown', function (e) {
    if (e.button !== 0 && e.pointerType === 'mouse') return;
    pararInercia();
    arrastando = true; idPonteiro = e.pointerId; moveu = 0;
    xInicial = e.clientX; xBase = x;
    ultimoX = e.clientX; ultimoT = e.timeStamp; velocidade = 0;
    rail.setPointerCapture(e.pointerId);
    rail.classList.add('is-dragging');
    if (hint) hint.classList.add('is-gone');
  });

  rail.addEventListener('pointermove', function (e) {
    if (!arrastando || e.pointerId !== idPonteiro) return;
    var d = e.clientX - xInicial;
    moveu = Math.max(moveu, Math.abs(d));
    var dt = e.timeStamp - ultimoT;
    if (dt > 0) velocidade = (e.clientX - ultimoX) / dt;
    ultimoX = e.clientX; ultimoT = e.timeStamp;
    aplicar(xBase + d);
  });

  function fim(e) {
    if (!arrastando || (e && e.pointerId !== idPonteiro)) return;
    arrastando = false; idPonteiro = null;
    rail.classList.remove('is-dragging');
    soltar();
  }
  rail.addEventListener('pointerup', fim);
  rail.addEventListener('pointercancel', fim);

  /* Um arraste não pode virar clique em link/imagem no fim do movimento. */
  rail.addEventListener('click', function (e) {
    if (moveu > 6) { e.preventDefault(); e.stopPropagation(); }
  }, true);

  /* Teclado: sem isso o carrossel não existe para quem não usa mouse. */
  rail.tabIndex = 0;
  rail.addEventListener('keydown', function (e) {
    var passo = rail.clientWidth * 0.6;
    if (e.key === 'ArrowRight') { pararInercia(); aplicar(x - passo); e.preventDefault(); }
    if (e.key === 'ArrowLeft')  { pararInercia(); aplicar(x + passo); e.preventDefault(); }
    if (e.key === 'Home')       { pararInercia(); aplicar(0); e.preventDefault(); }
    if (e.key === 'End')        { pararInercia(); aplicar(min); e.preventDefault(); }
  });

  window.addEventListener('resize', medir);
  if (document.fonts && document.fonts.ready) document.fonts.ready.then(medir);

  /* As fotos do carrossel são loading="lazy": no carregamento da página elas
     ainda não existem, os slides têm largura zero e o trilho mede ~350px em
     vez de ~2500px. Se a medição parar aí, o limite de arraste fica zero e o
     carrossel não anda. O ResizeObserver remede toda vez que o trilho muda de
     tamanho — ou seja, a cada foto que termina de carregar. */
  if (window.ResizeObserver) {
    var pendente = false;
    new ResizeObserver(function () {
      if (pendente) return;
      pendente = true;
      requestAnimationFrame(function () { pendente = false; medir(); });
    }).observe(track);
  } else {
    /* sem ResizeObserver, escuta o fim do carregamento de cada peça */
    Array.prototype.forEach.call(track.querySelectorAll('img, video'), function (m) {
      m.addEventListener('load', medir);
      m.addEventListener('loadedmetadata', medir);
    });
  }

  medir();
  setTimeout(medir, 300);
})();
